import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getNotificationHistoryCSV = (
  notificationId,
  NotificationDistributionLogId
) => {
  const url = `${apiConstants?.BASE_URL_1}/api/v1/CampaignDistribution/GetNotificationUserDistributionLogs?notificationId=${notificationId}&NotificationDistributionLogId=${NotificationDistributionLogId}`;
  const encodedUrl = encodeURIComponent(url);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ENGAGEMENT_CENTER.GET_NOTIFICATION_HISTORY_CSV(
      encodedUrl
    )
  );
};

export default getNotificationHistoryCSV;
